import React from "react"


export default class CopyBtn extends React.Component {
  state = {
    copied: false
  }
  handleCopy = () => {
    this.props.onClick()
    this.setState({copied: true})
    setTimeout(() => {
      this.setState({copied: false})
    }, 750)
  }
  render() {
    const { copied } = this.state
    return (
      <div className={"btn-wrapper"}>
        <button className={"copy"} onClick={this.handleCopy}>
          {
            copied ? <b>Copied</b>
              : <i className="fa fa-copy fa-lg"/>
          }
        </button>
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/components/Main/CopyBtn.js